/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@core/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _circle, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _circle2, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _circle3, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _circle4, _path164, _path165, _path166, _path167, _circle5, _circle6, _path168, _path169, _path170, _path171, _path172, _circle7, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _switch, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389;
const didWarnAboutDeprecation = {};
const VolumeDownFilled = /*#__PURE__*/React.forwardRef(function VolumeDownFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1,10.66,23.58,12a6,6,0,0,1-.18,7.94l1.47,1.36a8,8,0,0,0,.23-10.59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30a1,1,0,0,1-.71-.3L11.67,22H5a1,1,0,0,1-1-1H4V11a1,1,0,0,1,1-1h6.67l7.62-7.7a1,1,0,0,1,1.41,0A1,1,0,0,1,21,3V29A1,1,0,0,1,20,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeDownFilled.propTypes = iconPropTypes;
}
const VolumeDownFilledAlt = /*#__PURE__*/React.forwardRef(function VolumeDownFilledAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15H32V17H22z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30a.997.997,0,0,1-.7109-.2969L9.666,22H3a.9993.9993,0,0,1-1-.9988V11a.9993.9993,0,0,1,.9988-1H9.666l7.623-7.7031A1,1,0,0,1,19,3V29A1.0007,1.0007,0,0,1,18,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeDownFilledAlt.propTypes = iconPropTypes;
}
const VolumeFileStorage = /*#__PURE__*/React.forwardRef(function VolumeFileStorage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.707,17.293l-5-5A1,1,0,0,0,20,12H14a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V18A1,1,0,0,0,25.707,17.293ZM23.5857,18H20V14.4141ZM14,28V14h4v4a2,2,0,0,0,2,2h4v8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8,27H4a2.0023,2.0023,0,0,1-2-2V5A2.0023,2.0023,0,0,1,4,3h7.5857A1.9865,1.9865,0,0,1,13,3.5859L16.4143,7H28a2.0023,2.0023,0,0,1,2,2v8H28V9H15.5857l-4-4H4V25H8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeFileStorage.propTypes = iconPropTypes;
}
const VolumeMute = /*#__PURE__*/React.forwardRef(function VolumeMute({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30a1,1,0,0,1-.71-.3L9.67,22H3a1,1,0,0,1-1-1H2V11a1,1,0,0,1,1-1H9.67l7.62-7.7a1,1,0,0,1,1.41,0A1,1,0,0,1,19,3V29A1,1,0,0,1,18,30ZM4,20h6a1.17,1.17,0,0,1,.79.3L17,26.57V5.43L10.79,11.7A1.17,1.17,0,0,1,10,12H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeMute.propTypes = iconPropTypes;
}
const VolumeMuteFilled = /*#__PURE__*/React.forwardRef(function VolumeMuteFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30a1,1,0,0,1-.71-.3L9.67,22H3a1,1,0,0,1-1-1H2V11a1,1,0,0,1,1-1H9.67l7.62-7.7a1,1,0,0,1,1.41,0A1,1,0,0,1,19,3V29A1,1,0,0,1,18,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeMuteFilled.propTypes = iconPropTypes;
}
const VolumeObjectStorage = /*#__PURE__*/React.forwardRef(function VolumeObjectStorage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23,24a2.98,2.98,0,0,0-2.0376.8115l-4.0037-2.4023a2.0478,2.0478,0,0,0,0-.8184l4.0037-2.4023a3.2463,3.2463,0,1,0-.9211-1.7793l-4.0037,2.4023a3,3,0,1,0,0,4.377l4.0037,2.4023A2.9729,2.9729,0,0,0,20,27a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0008,1.0008,0,0,1,23,16Zm-9,7a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,14,23Zm9,5a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,23,28Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeObjectStorage.propTypes = iconPropTypes;
}
const VolumeUp = /*#__PURE__*/React.forwardRef(function VolumeUp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.58,12a6,6,0,0,1-.18,7.94l1.47,1.36a8,8,0,0,0,.23-10.59Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30a1,1,0,0,1-.71-.3L9.67,22H3a1,1,0,0,1-1-1H2V11a1,1,0,0,1,1-1H9.67l7.62-7.7a1,1,0,0,1,1.41,0A1,1,0,0,1,19,3V29A1,1,0,0,1,18,30ZM4,20h6.08a1,1,0,0,1,.71.3L17,26.57V5.43L10.79,11.7a1,1,0,0,1-.71.3H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeUp.propTypes = iconPropTypes;
}
const VolumeUpAlt = /*#__PURE__*/React.forwardRef(function VolumeUpAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30a.997.997,0,0,1-.7109-.2969L9.666,22H3a.9993.9993,0,0,1-1-.9988V11a.9993.9993,0,0,1,.9988-1H9.666l7.623-7.7031A1,1,0,0,1,19,3V29A1.0007,1.0007,0,0,1,18,30ZM4,20h6a1.2008,1.2008,0,0,1,.7939.2969L17,26.5684V5.4316l-6.2061,6.2715A1.2013,1.2013,0,0,1,10,12H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeUpAlt.propTypes = iconPropTypes;
}
const VolumeUpFilled = /*#__PURE__*/React.forwardRef(function VolumeUpFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.58,12a6,6,0,0,1-.18,7.94l1.47,1.36a8,8,0,0,0,.23-10.59Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30a1,1,0,0,1-.71-.3L9.67,22H3a1,1,0,0,1-1-1H2V11a1,1,0,0,1,1-1H9.67l7.62-7.7a1,1,0,0,1,1.41,0A1,1,0,0,1,19,3V29A1,1,0,0,1,18,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeUpFilled.propTypes = iconPropTypes;
}
const VolumeUpFilledAlt = /*#__PURE__*/React.forwardRef(function VolumeUpFilledAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30a.997.997,0,0,1-.7109-.2969L9.666,22H3a.9993.9993,0,0,1-1-.9988V11a.9993.9993,0,0,1,.9988-1H9.666l7.623-7.7031A1,1,0,0,1,19,3V29A1.0007,1.0007,0,0,1,18,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeUpFilledAlt.propTypes = iconPropTypes;
}
const Vpn = /*#__PURE__*/React.forwardRef(function Vpn({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H12V9h6a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H14Zm0-7h4V11H14Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19L24.32 9 22 9 22 23 24 23 24 13 27.68 23 30 23 30 9 28 9 28 19z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9L6 22 4 9 2 9 4.52 23 7.48 23 10 9 8 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Vpn.propTypes = iconPropTypes;
}
const VpnConnection = /*#__PURE__*/React.forwardRef(function VpnConnection({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28,7a1.9919,1.9919,0,0,0-1.7227,1H22A6,6,0,0,0,10,8H5.7227a2,2,0,1,0,0,2H10v4H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16a2,2,0,0,0-2-2H22V10h4.2773A1.9966,1.9966,0,1,0,28,7ZM12,8a4,4,0,0,1,8,0v6H12V10h5V8Zm12,8V28H8V16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VpnConnection.propTypes = iconPropTypes;
}
const VpnPolicy = /*#__PURE__*/React.forwardRef(function VpnPolicy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15A6,6,0,1,0,20,19.46V29l4-1.8838L28,29V19.46A5.98,5.98,0,0,0,30,15ZM26,25.8477l-2-.9415-2,.9415V20.65a5.8877,5.8877,0,0,0,4,0ZM24,19a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,19Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14,2A6.0066,6.0066,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H17V28H6V16h9V14H10V8a4,4,0,0,1,7.92-.8008l1.96-.3984A6.0167,6.0167,0,0,0,14,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VpnPolicy.propTypes = iconPropTypes;
}
const Wallet = /*#__PURE__*/React.forwardRef(function Wallet({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17H24V19H22z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H4V5H26V3H4A2,2,0,0,0,2,5V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM4,26V10H28v3H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h8v3ZM28,15v6H20V15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Wallet.propTypes = iconPropTypes;
}
const Warning = /*#__PURE__*/React.forwardRef(function Warning({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
    })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
      d: "M7.5 4H8.5V9H7.5z"
    })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
      d: "M8,10.2c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8S8.4,10.2,8,10.2z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8H17V19H15z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Warning.propTypes = iconPropTypes;
}
const WarningAlt = /*#__PURE__*/React.forwardRef(function WarningAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
      d: "M14.5,14h-13c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.3,0-0.5l6.5-12C7.7,1,8,0.9,8.2,1.1c0.1,0,0.2,0.1,0.2,0.2l6.5,12 c0.1,0.2,0.1,0.3,0,0.5C14.9,13.9,14.7,14,14.5,14z M2.3,13h11.3L8,2.5L2.3,13z"
    })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
      d: "M7.5 6H8.5V9.5H7.5z"
    })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
      d: "M8,10.8c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8S8.4,10.8,8,10.8z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,23Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H17V21H15z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningAlt.propTypes = iconPropTypes;
}
const WarningAltFilled = /*#__PURE__*/React.forwardRef(function WarningAltFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Zm-1.125-5h2.25V12h-2.25Z",
    "data-icon-path": "inner-path"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M16.002,6.1714h-.004L4.6487,27.9966,4.6506,28H27.3494l.0019-.0034ZM14.875,12h2.25v9h-2.25ZM16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningAltFilled.propTypes = iconPropTypes;
}
const WarningAltInverted = /*#__PURE__*/React.forwardRef(function WarningAltInverted({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M16,17a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,17Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H17V15H15z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningAltInverted.propTypes = iconPropTypes;
}
const WarningAltInvertedFilled = /*#__PURE__*/React.forwardRef(function WarningAltInvertedFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,20Zm-1.125-5h2.25V6h-2.25Z",
    "data-icon-path": "inner-path"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3494,4H4.6506l-.0019.0034L15.998,25.8286h.004L27.3513,4.0034ZM14.875,6h2.25v9h-2.25ZM16,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,20Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningAltInvertedFilled.propTypes = iconPropTypes;
}
const WarningDiamond = /*#__PURE__*/React.forwardRef(function WarningDiamond({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m16,20c-.8284,0-1.5.6716-1.5,1.5s.6716,1.5,1.5,1.5,1.5-.6716,1.5-1.5-.6716-1.5-1.5-1.5h0Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9H17V18H15z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m16,30c-.5335,0-1.0672-.2031-1.4732-.6094L2.6094,17.4732c-.8126-.8123-.8126-2.1342,0-2.9465L14.5268,2.6094c.8121-.8126,2.1344-.8126,2.9465,0l11.9173,11.9173c.8126.8123.8126,2.1342,0,2.9465l-11.9173,11.9173c-.406.4063-.9398.6094-1.4732.6094Zm0-26.0008c-.0215,0-.0427.0083-.0591.0244L4.0236,15.9409c-.0325.0327-.0325.0855,0,.1182l11.9173,11.9173c.0327.0322.0855.0322.1182,0l11.9173-11.9173c.0325-.0327.0325-.0855,0-.1182l-11.9173-11.9173c-.0164-.0161-.0376-.0244-.0591-.0244Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningDiamond.propTypes = iconPropTypes;
}
const WarningFilled = /*#__PURE__*/React.forwardRef(function WarningFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.2,1,1,4.2,1,8s3.2,7,7,7s7-3.1,7-7S11.9,1,8,1z M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2 c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z"
    })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
      d: "M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8 c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      ...rest
    }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
      d: "M10,1c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S15,1,10,1z M9.2,5h1.5v7H9.2V5z M10,16c-0.6,0-1-0.4-1-1s0.4-1,1-1 s1,0.4,1,1S10.6,16,10,16z"
    })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
      d: "M9.2,5h1.5v7H9.2V5z M10,16c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,16,10,16z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  if (size === 24 || size === "24" || size === "24px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      ...rest
    }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
      d: "M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11C23,5.9,18.1,1,12,1z M11.1,6h1.8v8h-1.8V6z M12,19.2 c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2S12.7,19.2,12,19.2z"
    })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
      fill: "none",
      d: "M13.2,18c0,0.7-0.6,1.2-1.2,1.2s-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2S13.2,17.3,13.2,18z M12.9,6 h-1.8v8h1.8V6z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14C30,8.3,23.7,2,16,2z M14.9,8h2.2v11h-2.2V8z M16,25 c-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22c0.8,0,1.5,0.7,1.5,1.5S16.8,25,16,25z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M17.5,23.5c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22 C16.8,22,17.5,22.7,17.5,23.5z M17.1,8h-2.2v11h2.2V8z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningFilled.propTypes = iconPropTypes;
}
const WarningHex = /*#__PURE__*/React.forwardRef(function WarningHex({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M16,21a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,21Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8H17V18H15z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M23,29H9a1,1,0,0,1-.8638-.4961l-7-12a1,1,0,0,1,0-1.0078l7-12A1,1,0,0,1,9,3H23a1,1,0,0,1,.8638.4961l7,12a1,1,0,0,1,0,1.0078l-7,12A1,1,0,0,1,23,29ZM9.5742,27H22.4258l6.4165-11L22.4258,5H9.5742L3.1577,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningHex.propTypes = iconPropTypes;
}
const WarningHexFilled = /*#__PURE__*/React.forwardRef(function WarningHexFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z",
    "data-icon-path": "inner-path"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8508,15.4487,23.8867,3.5322A1.0687,1.0687,0,0,0,22.9643,3H9.0357a1.0687,1.0687,0,0,0-.9224.5322L1.1492,15.4487a1.0933,1.0933,0,0,0,0,1.1026L8.1133,28.4678A1.0687,1.0687,0,0,0,9.0357,29H22.9643a1.0687,1.0687,0,0,0,.9224-.5322l6.9641-11.9165A1.0933,1.0933,0,0,0,30.8508,15.4487ZM14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningHexFilled.propTypes = iconPropTypes;
}
const WarningMultiple = /*#__PURE__*/React.forwardRef(function WarningMultiple({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m29,23h-4v-2h2.3821l-7.8821-15.7639-1.1055,2.2112-1.7891-.8945,2-4c.1694-.3387.532-.5527.8945-.5527s.7251.214.8945.5527l9.5,19c.1548.3101.1384.6782-.0439.973-.1821.2948-.5039.4742-.8506.4742Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "25",
    r: "1.25"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15H15V22H13z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m25,30H3c-.3499,0-.6743-.1829-.8555-.4823s-.1926-.6718-.0303-.9817L13.1143,7.536c.1726-.3296.5292-.536.8857-.536s.7131.2064.8857.536l11,21c.1624.3099.1509.6823-.0303.9817s-.5056.4823-.8555.4823Zm-20.3474-2h18.6948L14,10.1552,4.6526,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningMultiple.propTypes = iconPropTypes;
}
const WarningOther = /*#__PURE__*/React.forwardRef(function WarningOther({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20H30V22H18z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24H30V26H18z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M18 28H30V30H18z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M14,18a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,14,18Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7H15V16H13z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M14,4A10.0111,10.0111,0,0,1,24,14h2A12,12,0,1,0,14,26V24A10,10,0,0,1,14,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningOther.propTypes = iconPropTypes;
}
const WarningSquare = /*#__PURE__*/React.forwardRef(function WarningSquare({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,20Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9H17V18H15z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningSquare.propTypes = iconPropTypes;
}
const WarningSquareFilled = /*#__PURE__*/React.forwardRef(function WarningSquareFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0022,4H5.998A1.998,1.998,0,0,0,4,5.998V26.002A1.998,1.998,0,0,0,5.998,28H26.0022A1.9979,1.9979,0,0,0,28,26.002V5.998A1.9979,1.9979,0,0,0,26.0022,4ZM14.8752,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.8751,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningSquareFilled.propTypes = iconPropTypes;
}
const Watch = /*#__PURE__*/React.forwardRef(function Watch({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h1v6h2V24h6v6h2V24h1a2,2,0,0,0,2-2V10A2,2,0,0,0,22,8ZM10,22V10H22V22Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M25 14H27V18H25z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Watch.propTypes = iconPropTypes;
}
const Watson = /*#__PURE__*/React.forwardRef(function Watson({
  children,
  size = 16,
  ...rest
}, ref) {
  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation["Watson"]) {
      didWarnAboutDeprecation["Watson"] = true;
      console.warn("Icon represents the old avatar for the Watson brand, which is retired since the watsonx brand launch. Replaced by the icon watsonx. As a result, the Watson component will be removed in the next major version of @carbon/icons-react.");
    }
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M21.74,9.49h0A11.41,11.41,0,0,0,16,8h0a.76.76,0,1,0,0,1.51,10.15,10.15,0,0,1,1.91.21c-2.26,1.08-4.76,3.58-6.73,7a22.48,22.48,0,0,0-2,4.44A9.58,9.58,0,0,1,7,17.22a3.43,3.43,0,0,1,.28-2.66v0h0c.79-1.37,2.44-2.15,4.63-2.2a.76.76,0,0,0,.74-.78.75.75,0,0,0-.78-.74C9.19,10.88,7.1,11.92,6,13.74H6v0s0,0,0,0a4.84,4.84,0,0,0-.44,3.79,12,12,0,0,0,3.2,5.22A11.36,11.36,0,0,0,8.52,26a10,10,0,0,1-2-3.48A.75.75,0,0,0,5.57,22a.76.76,0,0,0-.49,1,11.45,11.45,0,0,0,5.18,6.38h0A11.42,11.42,0,0,0,16,30.92a11.74,11.74,0,0,0,3-.39,11.48,11.48,0,0,0,2.77-21ZM18.58,29.06a9.9,9.9,0,0,1-7.56-1h0c-.86-.49-1.21-2-.94-4a18.85,18.85,0,0,0,2.48,1.72,13.92,13.92,0,0,0,6.93,2,11,11,0,0,0,2.42-.28A9.78,9.78,0,0,1,18.58,29.06Zm6.06-4.66c-2,2-6.66,2.74-11.32.05a17.36,17.36,0,0,1-2.89-2.12,21.08,21.08,0,0,1,2.08-4.91c2.94-5.08,6.83-7.57,8.47-6.62h0A10,10,0,0,1,24.64,24.4Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16,11.72,1.14,10a.76.76,0,1,0-.76,1.31L3.4,13a.86.86,0,0,0,.38.1.77.77,0,0,0,.66-.38A.76.76,0,0,0,4.16,11.72Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29,7.59A.74.74,0,0,0,8.94,8a.75.75,0,0,0,.38-.1.76.76,0,0,0,.28-1l-1.74-3a.76.76,0,0,0-1-.27.75.75,0,0,0-.28,1Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6.08a.76.76,0,0,0,.76-.76V1.83a.76.76,0,0,0-1.52,0V5.32A.76.76,0,0,0,16,6.08Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M22.68,7.87a.75.75,0,0,0,1-.28l1.75-3a.75.75,0,0,0-.28-1,.76.76,0,0,0-1,.27l-1.74,3A.76.76,0,0,0,22.68,7.87Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9,10.25a.76.76,0,0,0-1-.27l-3,1.74a.76.76,0,0,0-.28,1,.77.77,0,0,0,.66.38.86.86,0,0,0,.38-.1l3-1.75A.76.76,0,0,0,31.9,10.25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Watson.propTypes = iconPropTypes;
}
const WatsonMachineLearning = /*#__PURE__*/React.forwardRef(function WatsonMachineLearning({
  children,
  size = 16,
  ...rest
}, ref) {
  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation["WatsonMachineLearning"]) {
      didWarnAboutDeprecation["WatsonMachineLearning"] = true;
      console.warn("Icon design is defunct, replaced with the existing icon ibm-watson--machine-learning. As a result, the WatsonMachineLearning component will be removed in the next major version of @carbon/icons-react.");
    }
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M22,26H20V17.76l-3.23,3.88a1,1,0,0,1-1.54,0L12,17.76V26H10V15a1,1,0,0,1,.66-.94,1,1,0,0,1,1.11.3L16,19.44l4.23-5.08a1,1,0,0,1,1.11-.3A1,1,0,0,1,22,15Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16,14.65l-3-1.75a.76.76,0,1,0-.76,1.32L3.4,16a.76.76,0,1,0,.76-1.31Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29,10.52a.73.73,0,0,0,1,.27.75.75,0,0,0,.28-1l-1.74-3a.76.76,0,1,0-1.32.76Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9a.76.76,0,0,0,.76-.76V4.76a.76.76,0,1,0-1.52,0V8.25A.76.76,0,0,0,16,9Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M22.68,10.79a.75.75,0,0,0,.37.11.76.76,0,0,0,.66-.38l1.75-3a.76.76,0,0,0-1.32-.76l-1.74,3A.75.75,0,0,0,22.68,10.79Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9,13.18a.76.76,0,0,0-1-.28l-3,1.75A.76.76,0,0,0,28.6,16l3-1.74A.77.77,0,0,0,31.9,13.18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonMachineLearning.propTypes = iconPropTypes;
}
const Watsonx = /*#__PURE__*/React.forwardRef(function Watsonx({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29.312,22.9189c1.1042-2.1201,1.688-4.5127,1.688-6.9189C31,7.729,24.271,1,16,1c-3.3738,0-6.5815,1.1191-9.2046,3.1665-.2441-.106-.5125-.1665-.7954-.1665-1.1045,0-2,.8955-2,2s.8955,2,2,2,2-.8955,2-2c0-.0762-.0142-.1489-.0225-.2227,2.2812-1.7964,5.0793-2.7773,8.0225-2.7773.9727,0,1.9172.1157,2.8293.3193-3.3938.9258-5.8994,4.0273-5.8994,7.7109,0,.7891.1167,1.5503.332,2.27-.6985-.2021-1.4285-.3306-2.1919-.3306-3.7039,0-6.8191,2.5342-7.7256,5.957-.218-.9424-.3445-1.9189-.3445-2.9268,0-2.1162.4919-4.1328,1.4619-5.9951l-1.7739-.9238c-1.1042,2.1201-1.688,4.5127-1.688,6.9189,0,8.271,6.729,15,15,15,3.3738,0,6.5815-1.1191,9.2046-3.1665.2441.106.5125.1665.7954.1665,1.1045,0,2-.8955,2-2s-.8955-2-2-2-2,.8955-2,2c0,.0762.0142.1489.0225.2231-1.0796.8496-2.2776,1.5098-3.5493,1.9771.3315-.6641.5269-1.4072.5269-2.2002,0-1.6304-.7959-3.0669-2.0068-3.9805.0457-.3472.0769-.6978.0769-1.0498,0-.7856-.1257-1.54-.3381-2.2573.6995.2012,1.4346.3179,2.198.3179,3.7039,0,6.8191-2.5342,7.7256-5.957.218.9424.3445,1.9189.3445,2.9268,0,2.1162-.4919,4.1328-1.4619,5.9951l1.7739.9238Zm-17.7935,5.2646c-1.8389-.6807-3.49-1.7529-4.8325-3.1338-1.0366-1.1143-1.616-2.5527-1.616-4.0801,0-3.3081,2.6917-6,6-6s6,2.6919,6,6c0,.0498-.0125.0977-.0134.1475-.3413-.0737-.6936-.1172-1.0566-.1172-2.7571,0-5,2.2432-5,5,0,.7861.1924,1.5234.5186,2.1836Zm7.4814-2.1836c0,1.6543-1.3457,3-3,3s-3-1.3457-3-3,1.3457-3,3-3,3,1.3457,3,3Zm1.9299-8.9697c-3.3083,0-6-2.6919-6-6s2.6917-6,6-6c1.4294,0,2.7422.5039,3.7742,1.3418.3027.2739.5918.561.8677.8618.8479,1.0352,1.3582,2.3569,1.3582,3.7964,0,3.3081-2.6917,6-6,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Watsonx.propTypes = iconPropTypes;
}
const WatsonxAi = /*#__PURE__*/React.forwardRef(function WatsonxAi({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "m26,24c-1.1046,0-2,.8954-2,2,0,.0764.0142.1488.0225.2229-2.2808,1.7963-5.0792,2.7771-8.0225,2.7771-4.2617,0-8-3.9722-8-8.5,0-4.687,3.813-8.5,8.5-8.5h.5v-2h-.5c-5.7896,0-10.5,4.7104-10.5,10.5,0,1.8839.5304,3.6896,1.4371,5.2565-2.7133-2.3843-4.4371-5.869-4.4371-9.7565,0-2.1152.4917-4.1328,1.4619-5.9956l-1.7744-.9238c-1.104,2.1211-1.6875,4.5137-1.6875,6.9194,0,8.271,6.729,15,15,15,3.3744,0,6.5818-1.1193,9.2048-3.1662.244.106.5123.1662.7952.1662,1.1046,0,2-.8954,2-2s-.8954-2-2-2Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20H13V22H11z",
    transform: "rotate(90 12 21)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10H21V12H19z",
    transform: "rotate(90 20 11)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-3.3744,0-6.5818,1.1193-9.2048,3.1662-.244-.106-.5123-.1662-.7952-.1662-1.1046,0-2,.8954-2,2s.8954,2,2,2,2-.8954,2-2c0-.0764-.0142-.1488-.0225-.2229,2.2808-1.7963,5.0792-2.7771,8.0225-2.7771,4.2617,0,8,3.9722,8,8.5,0,4.687-3.813,8.5-8.5,8.5h-.5v2h.5c5.7896,0,10.5-4.7104,10.5-10.5,0-1.8853-.5322-3.6917-1.4401-5.2593,2.715,2.3843,4.4401,5.8704,4.4401,9.7593,0,2.1152-.4917,4.1328-1.4619,5.9956l1.7744.9238c1.104-2.1211,1.6875-4.5137,1.6875-6.9194C31,7.729,24.271,1,16,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonxAi.propTypes = iconPropTypes;
}
const WatsonxData = /*#__PURE__*/React.forwardRef(function WatsonxData({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "m26,24c-1.1046,0-2,.8954-2,2,0,.0764.0142.1488.0225.2229-2.2808,1.7963-5.0792,2.7771-8.0225,2.7771-2.7746,0-5.3432-.881-7.4566-2.3676.2576.0261.517.0444.7798.0444,4.2329,0,7.6768-3.4438,7.6768-7.6768h-2c0,3.1304-2.5464,5.6768-5.6768,5.6768-2.2111,0-4.1977-1.2816-5.1318-3.2725-.1365-.2972-.2595-.6007-.3738-.9094.6602.322,1.3998.5051,2.1824.5051,2.7568,0,5-2.2432,5-5v-2h-2v2c0,1.6543-1.3457,3-3,3s-3-1.3457-3-3c0-2.1152.4917-4.1328,1.4619-5.9956l-1.7744-.9238c-1.104,2.1211-1.6875,4.5137-1.6875,6.9194,0,8.271,6.729,15,15,15,3.3744,0,6.5818-1.1193,9.2048-3.1662.244.106.5123.1662.7952.1662,1.1046,0,2-.8954,2-2s-.8954-2-2-2Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21H23V23H21z",
    transform: "rotate(90 22 22)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15H17V17H15z",
    transform: "rotate(90 16 16)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9H11V11H9z",
    transform: "rotate(-90 10 10)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-3.3744,0-6.5818,1.1193-9.2048,3.1662-.244-.106-.5123-.1662-.7952-.1662-1.1046,0-2,.8954-2,2s.8954,2,2,2,2-.8954,2-2c0-.0764-.0142-.1488-.0225-.2229,2.2808-1.7963,5.0792-2.7771,8.0225-2.7771,2.7708,0,5.3363.8784,7.4481,2.3613-.249-.0242-.5005-.038-.7547-.038-4.2329,0-7.6768,3.4438-7.6768,7.6768h2c0-3.1304,2.5464-5.6768,5.6768-5.6768,2.0554,0,3.9068,1.0953,4.9186,2.8651.2153.4283.4053.8701.5729,1.3237-.6615-.3234-1.4005-.5121-2.1849-.5121-2.7568,0-5,2.2432-5,5v2h2v-2c0-1.6543,1.3457-3,3-3s3,1.3457,3,3c0,2.1152-.4917,4.1328-1.4619,5.9956l1.7744.9238c1.104-2.1211,1.6875-4.5137,1.6875-6.9194C31,7.729,24.271,1,16,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonxData.propTypes = iconPropTypes;
}
const WatsonxGovernance = /*#__PURE__*/React.forwardRef(function WatsonxGovernance({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "m26,24c-1.1046,0-2,.8954-2,2,0,.0764.0142.1488.0225.2229-2.2808,1.7963-5.0792,2.7771-8.0225,2.7771-7.1685,0-13-5.8315-13-13,0-2.1152.4917-4.1328,1.4619-5.9956l-1.7744-.9238c-1.104,2.1211-1.6875,4.5137-1.6875,6.9194,0,8.271,6.729,15,15,15,3.3744,0,6.5818-1.1193,9.2048-3.1662.244.106.5123.1662.7952.1662,1.1046,0,2-.8954,2-2s-.8954-2-2-2Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M11 23H13V25H11z",
    transform: "rotate(90 12 24)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9H13V11H11z",
    transform: "rotate(90 12 10)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16H13V18H11z",
    transform: "rotate(90 12 17)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-3.3744,0-6.5818,1.1193-9.2048,3.1662-.244-.106-.5123-.1662-.7952-.1662-1.1046,0-2,.8954-2,2s.8954,2,2,2,2-.8954,2-2c0-.0764-.0142-.1488-.0225-.2229,2.2808-1.7963,5.0792-2.7771,8.0225-2.7771,1.6543,0,3,1.3457,3,3s-1.3457,3-3,3h-1v2h1c2.7568,0,5-2.2432,5-5,0-.2399-.0203-.4748-.0531-.7057.9663,1.1348,1.5531,2.6021,1.5531,4.2057,0,3.584-2.916,6.5-6.5,6.5h-1v2h1c4.687,0,8.5-3.813,8.5-8.5,0-.7654-.1111-1.5036-.3017-2.2096,1.1321,1.6206,1.8017,3.587,1.8017,5.7096,0,5.5142-4.4858,10-10,10h-1v2h1c6.6167,0,12-5.3833,12-12,0-.8995-.1058-1.774-.2944-2.6176.8207,1.7031,1.2944,3.6038,1.2944,5.6176,0,2.1152-.4917,4.1328-1.4619,5.9956l1.7744.9238c1.104-2.1211,1.6875-4.5137,1.6875-6.9194C31,7.729,24.271,1,16,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonxGovernance.propTypes = iconPropTypes;
}
const WaveDirection = /*#__PURE__*/React.forwardRef(function WaveDirection({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H17a7.0078,7.0078,0,0,1-7-7,6.6832,6.6832,0,0,1,2.0244-4.6967A6.7126,6.7126,0,0,0,10.0093,18C5.0425,18.0466,4,24.5513,4,30H2C2,18.4907,6.3452,16.0342,9.9907,16a10.0962,10.0962,0,0,1,4.4785,1.117,1,1,0,0,1,.0616,1.73A4.8773,4.8773,0,0,0,17,28h5Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M18,24V22a8,8,0,1,0-8-8H8A10,10,0,1,1,18,24Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "8",
    r: "1"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17.5859l-2.3-2.3007A2.9665,2.9665,0,0,0,21,14a3.0033,3.0033,0,0,0-3-3,2.9609,2.9609,0,0,0-1.2854.3008L14.4141,9,13,10.4141l2.3,2.3007A2.9665,2.9665,0,0,0,15,14a3.0033,3.0033,0,0,0,3,3,2.9609,2.9609,0,0,0,1.2854-.3008L21.5859,19ZM17,14a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,17,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WaveDirection.propTypes = iconPropTypes;
}
const WaveHeight = /*#__PURE__*/React.forwardRef(function WaveHeight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M24 2H30V4H24z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8H28V10H24z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14H30V16H24z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20H28V22H24z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28H24a10.0349,10.0349,0,0,1-6.9268-17.2622A11.9629,11.9629,0,0,0,12.9937,10a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,16.4348,4,21.34,4,28H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,8h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,26h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WaveHeight.propTypes = iconPropTypes;
}
const WavePeriod = /*#__PURE__*/React.forwardRef(function WavePeriod({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H17a7.0078,7.0078,0,0,1-7-7,6.6832,6.6832,0,0,1,2.0244-4.6967A6.7935,6.7935,0,0,0,10.0093,18C5.0425,18.0466,4,24.5513,4,30H2C2,18.4907,6.3452,16.0342,9.9907,16a10.0717,10.0717,0,0,1,4.4785,1.117,1,1,0,0,1,.0616,1.73A4.8773,4.8773,0,0,0,17,28h5Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8H19V16H17z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5.4141,26.5859,4,24.3242,6.2617A9.95,9.95,0,0,0,19,4.0508V2H17V4.0508A10.0132,10.0132,0,0,0,8,14h2a8,8,0,1,1,8,8v2A9.9928,9.9928,0,0,0,25.7383,7.6758Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WavePeriod.propTypes = iconPropTypes;
}
const WeatherFrontCold = /*#__PURE__*/React.forwardRef(function WeatherFrontCold({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1655,2a13.0289,13.0289,0,0,0-12.542,9.5791l-1.1767,4.3154A11.0237,11.0237,0,0,1,3.8345,24H2v2H3.8345c.2975,0,.5918-.0171.8853-.0371l7.9291,2.9736A1,1,0,0,0,14,28V21.0923a12.9311,12.9311,0,0,0,.9121-1.313l6.3628-1.8179a1,1,0,0,0,.5059-1.5864L17.7843,11.38a10.9268,10.9268,0,0,1,1.1516-2.3472l5.7477,1.916A1,1,0,0,0,26,10V4.2251A10.8956,10.8956,0,0,1,28.1655,4H30V2ZM8.3354,25.1826A13.047,13.047,0,0,0,12,23.0943v3.4624Zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28,16.4512ZM24,8.6123l-3.7411-1.247A11.0712,11.0712,0,0,1,24,4.8306Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WeatherFrontCold.propTypes = iconPropTypes;
}
const WeatherFrontStationary = /*#__PURE__*/React.forwardRef(function WeatherFrontStationary({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1655,2a12.9848,12.9848,0,0,0-8.4074,3.1065A3.9947,3.9947,0,1,0,15.583,11.728l-1.1362,4.1665c-.0725.2657-.1579.5254-.2489.7818a3.9864,3.9864,0,0,0-5.1547,6.0054A10.9541,10.9541,0,0,1,3.8345,24H2v2H3.8345c.2975,0,.5918-.0171.8853-.0371l7.9291,2.9736A1,1,0,0,0,14,28V21.0923a12.9311,12.9311,0,0,0,.9121-1.313l6.3628-1.8179a1,1,0,0,0,.5059-1.5864L17.7843,11.38a10.9268,10.9268,0,0,1,1.1516-2.3472l5.7477,1.916A1,1,0,0,0,26,10V4.2251A10.8956,10.8956,0,0,1,28.1655,4H30V2ZM17,6a1.98,1.98,0,0,1,1.3237.53A12.9413,12.9413,0,0,0,16.24,9.8482,1.9988,1.9988,0,0,1,17,6ZM10,20a1.9879,1.9879,0,0,1,3.3374-1.4717,11.0157,11.0157,0,0,1-2.5959,3.0147A1.9975,1.9975,0,0,1,10,20ZM8.3354,25.1826A13.047,13.047,0,0,0,12,23.0943v3.4624Zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28,16.4512ZM24,8.6123l-3.7411-1.247A11.0712,11.0712,0,0,1,24,4.8306Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22L22 24 26.586 24 22 28.586 23.414 30 28 25.414 28 30 30 30 30 22 22 22z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L2 4 6.586 4 2 8.586 3.414 10 8 5.414 8 10 10 10 10 2 2 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WeatherFrontStationary.propTypes = iconPropTypes;
}
const WeatherFrontWarm = /*#__PURE__*/React.forwardRef(function WeatherFrontWarm({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1655,2a13.0289,13.0289,0,0,0-12.542,9.5791l-1.1767,4.3154A11.0237,11.0237,0,0,1,3.8345,24H2v2H3.8345a12.9139,12.9139,0,0,0,3.4687-.4819,3.9979,3.9979,0,1,0,6.5818-4.2866,12.9671,12.9671,0,0,0,1.6209-2.5269,3.9944,3.9944,0,1,0,2.3772-7.5991,10.95,10.95,0,0,1,1.7253-3.01,3.9825,3.9825,0,0,0,6.9058-3.9648A10.9435,10.9435,0,0,1,28.1655,4H30V2ZM11,26a1.9983,1.9983,0,0,1-1.8118-1.1655,13.0811,13.0811,0,0,0,3.2969-2.1426A1.9773,1.9773,0,0,1,11,26Zm8-11a1.9926,1.9926,0,0,1-2.759,1.8467c.0442-.1426.0959-.2813.1355-.4258L17.301,13.03A1.9976,1.9976,0,0,1,19,15Zm6-9a1.9942,1.9942,0,0,1-3.9011.5894,11.0511,11.0511,0,0,1,3.3623-1.9385A1.995,1.995,0,0,1,25,6Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WeatherFrontWarm.propTypes = iconPropTypes;
}
const WeatherStation = /*#__PURE__*/React.forwardRef(function WeatherStation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M17,28V17h1a2.0023,2.0023,0,0,0,2-2V11a2.0023,2.0023,0,0,0-2-2H14a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h1V28H2v2H30V28ZM14,11h4l.0015,4H14Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3325,18.2168a7.0007,7.0007,0,0,1,0-10.4341l1.334,1.49a5,5,0,0,0,0,7.4537Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M22.667,18.2168l-1.334-1.49a4.9995,4.9995,0,0,0,0-7.4537l1.334-1.49a7,7,0,0,1,0,10.4341Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3994,21.8008a11.0019,11.0019,0,0,1,0-17.6006L7.6,5.8a9.0009,9.0009,0,0,0,0,14.4014Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6006,21.8008l-1.2012-1.6a9.001,9.001,0,0,0,0-14.4019l1.2012-1.6a11.002,11.002,0,0,1,0,17.6011Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WeatherStation.propTypes = iconPropTypes;
}
const WebServicesCluster = /*#__PURE__*/React.forwardRef(function WebServicesCluster({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "m16,26c-.2559,0-.512-.0977-.707-.2928l-3-3c-.1953-.1953-.293-.4512-.293-.7071s.0977-.5118.293-.7072l3-3c.1951-.1952.451-.2928.707-.2928s.512.0977.707.2928l3,3c.1953.1953.293.4512.293.7071s-.0977.5118-.293.7072l-3,3c-.1951.1952-.4512.2928-.707.2928Zm-1.5857-4l1.5857,1.5858,1.5857-1.5858-1.5857-1.5858-1.5857,1.5858Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "m22,20c-.2559,0-.512-.0977-.707-.2928l-3-3c-.1953-.1953-.293-.4512-.293-.7071s.0977-.5118.293-.7072l3-3c.1951-.1952.451-.2928.707-.2928s.512.0977.707.2928l3,3c.1953.1953.293.4512.293.7071s-.0977.5118-.293.7072l-3,3c-.1951.1952-.4512.2928-.707.2928Zm-1.5857-4l1.5857,1.5858,1.5857-1.5858-1.5857-1.5858-1.5857,1.5858Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "m16,14c-.2559,0-.512-.0977-.707-.2928l-3-3c-.1953-.1953-.293-.4512-.293-.7071s.0977-.5118.293-.7072l3-3c.1951-.1952.451-.2928.707-.2928s.512.0977.707.2928l3,3c.1953.1953.293.4512.293.7071s-.0977.5118-.293.7072l-3,3c-.1951.1952-.4512.2928-.707.2928Zm-1.5857-4l1.5857,1.5858,1.5857-1.5858-1.5857-1.5858-1.5857,1.5858Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "m10,20c-.2559,0-.512-.0977-.707-.2928l-3-3c-.1953-.1953-.293-.4512-.293-.7071s.0977-.5118.293-.7072l3-3c.1951-.1952.451-.2928.707-.2928s.512.0977.707.2928l3,3c.1953.1953.293.4512.293.7071s-.0977.5118-.293.7072l-3,3c-.1951.1952-.4512.2928-.707.2928Zm-1.5857-4l1.5857,1.5858,1.5857-1.5858-1.5857-1.5858-1.5857,1.5858Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-.1741,0-.3481.0454-.5039.1362L3.4961,8.1362c-.3071.1792-.4961.5081-.4961.8638v14c0,.3557.189.6846.4961.8638l12,7c.1558.0908.3298.1362.5039.1362s.3481-.0454.5039-.1362l11-6.4166-1.0078-1.7275-10.4961,6.1227-11-6.4166v-12.8513L16,3.1577l11,6.4166v7.4257h2v-8c0-.3557-.189-.6846-.4961-.8638L16.5039,1.1362c-.1558-.0908-.3298-.1362-.5039-.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WebServicesCluster.propTypes = iconPropTypes;
}
const WebServicesContainer = /*#__PURE__*/React.forwardRef(function WebServicesContainer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "m22.5046,11.6367l-5.9883-3.5c-.1594-.0933-.3381-.1387-.5164-.1367-.1699.002-.3394.0474-.4915.1357l-6.0117,3.5c-.3076.1792-.4968.5083-.4968.8643v7c0,.356.1892.6851.4968.8643l6.0117,3.5c.1555.0903.3176.1357.4915.1357.1743,0,.3604-.0454.5164-.1367l5.9883-3.5c.3069-.1792.4954-.5078.4954-.8633v-7c0-.3555-.1885-.6841-.4954-.8633Zm-6.4939-1.479l4.0076,2.3423-4.0076,2.3423-4.0232-2.3423,4.0232-2.3423Zm-5.0107,4.0815l4,2.3291v4.6855l-4-2.3291v-4.6855Zm6,7.0249v-4.6836l4-2.3379v4.6836l-4,2.3379Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-.1741,0-.3481.0454-.5039.1362L3.4961,8.1362c-.3071.1792-.4961.5081-.4961.8638v14c0,.3557.189.6846.4961.8638l12,7c.1558.0908.3298.1362.5039.1362s.3481-.0454.5039-.1362l11-6.4166-1.0078-1.7275-10.4961,6.1227-11-6.4166v-12.8513L16,3.1577l11,6.4166v7.4257h2v-8c0-.3557-.189-.6846-.4961-.8638L16.5039,1.1362c-.1558-.0908-.3298-.1362-.5039-.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WebServicesContainer.propTypes = iconPropTypes;
}
const WebServicesDefinition = /*#__PURE__*/React.forwardRef(function WebServicesDefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17H16V19H14z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13H18V15H14z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "m21,23h-10c-.5522,0-1-.4478-1-1v-12c0-.5522.4478-1,1-1h10c.5522,0,1,.4478,1,1v12c0,.5522-.4478,1-1,1Zm-9-2h8v-10h-8v10Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-.1741,0-.3481.0454-.5039.1362L3.4961,8.1362c-.3071.1792-.4961.5081-.4961.8638v14c0,.3557.189.6846.4961.8638l12,7c.1558.0908.3298.1362.5039.1362s.3481-.0454.5039-.1362l11-6.4166-1.0078-1.7275-10.4961,6.1227-11-6.4166v-12.8513L16,3.1577l11,6.4166v7.4257h2v-8c0-.3557-.189-.6846-.4961-.8638L16.5039,1.1362c-.1558-.0908-.3298-.1362-.5039-.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WebServicesDefinition.propTypes = iconPropTypes;
}
const WebServicesService = /*#__PURE__*/React.forwardRef(function WebServicesService({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "m23,18h-2v-7h-7v-2h8c.5522,0,1,.4478,1,1v8Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "m18,23h-8c-.5522,0-1-.4478-1-1v-8c0-.5522.4478-1,1-1h8c.5522,0,1,.4478,1,1v8c0,.5522-.4478,1-1,1Zm-7-2h6v-6h-6v6Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-.1741,0-.3481.0454-.5039.1362L3.4961,8.1362c-.3071.1792-.4961.5081-.4961.8638v14c0,.3557.189.6846.4961.8638l12,7c.1558.0908.3298.1362.5039.1362s.3481-.0454.5039-.1362l11-6.4166-1.0078-1.7275-10.4961,6.1227-11-6.4166v-12.8513L16,3.1577l11,6.4166v7.4257h2v-8c0-.3557-.189-.6846-.4961-.8638L16.5039,1.1362c-.1558-.0908-.3298-.1362-.5039-.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WebServicesService.propTypes = iconPropTypes;
}
const WebServicesTask = /*#__PURE__*/React.forwardRef(function WebServicesTask({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.18L18.41 18.59 17 20 20 23 25 18 23.59 16.59 20 20.18z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "m15,23h-4c-.5522,0-1-.4478-1-1v-12c0-.5522.4478-1,1-1h10c.5522,0,1,.4478,1,1v6h-2v-5h-8v10h3v2Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-.1741,0-.3481.0454-.5039.1362L3.4961,8.1362c-.3071.1792-.4961.5081-.4961.8638v14c0,.3557.189.6846.4961.8638l12,7c.1558.0908.3298.1362.5039.1362s.3481-.0454.5039-.1362l11-6.4166-1.0078-1.7275-10.4961,6.1227-11-6.4166v-12.8513L16,3.1577l11,6.4166v7.4257h2v-8c0-.3557-.189-.6846-.4961-.8638L16.5039,1.1362c-.1558-.0908-.3298-.1362-.5039-.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WebServicesTask.propTypes = iconPropTypes;
}
const WebServicesTaskDefinitionVersion = /*#__PURE__*/React.forwardRef(function WebServicesTaskDefinitionVersion({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15L22.25 15 20 22.0312 17.7917 15.0003 16 15.0003 18.5 23 21.5 23 24 15z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "m16,23h-5c-.5522,0-1-.4478-1-1v-12c0-.5522.4478-1,1-1h10c.5522,0,1,.4478,1,1v4h-2v-3h-8v10h4v2Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-.1741,0-.3481.0454-.5039.1362L3.4961,8.1362c-.3071.1792-.4961.5081-.4961.8638v14c0,.3557.189.6846.4961.8638l12,7c.1558.0908.3298.1362.5039.1362s.3481-.0454.5039-.1362l11-6.4166-1.0078-1.7275-10.4961,6.1227-11-6.4166v-12.8513L16,3.1577l11,6.4166v7.4257h2v-8c0-.3557-.189-.6846-.4961-.8638L16.5039,1.1362c-.1558-.0908-.3298-.1362-.5039-.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WebServicesTaskDefinitionVersion.propTypes = iconPropTypes;
}
const Webhook = /*#__PURE__*/React.forwardRef(function Webhook({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M24,26a3,3,0,1,0-2.8164-4H13v1a5,5,0,1,1-5-5V16a7,7,0,1,0,6.9287,8h6.2549A2.9914,2.9914,0,0,0,24,26Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M24,16a7.024,7.024,0,0,0-2.57.4873l-3.1656-5.5395a3.0469,3.0469,0,1,0-1.7326.9985l4.1189,7.2085.8686-.4976a5.0006,5.0006,0,1,1-1.851,6.8418L17.937,26.501A7.0005,7.0005,0,1,0,24,16Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M8.532,20.0537a3.03,3.03,0,1,0,1.7326.9985C11.74,18.47,13.86,14.7607,13.89,14.708l.4976-.8682-.8677-.497a5,5,0,1,1,6.812-1.8438l1.7315,1.002a7.0008,7.0008,0,1,0-10.3462,2.0356c-.457.7427-1.1021,1.8716-2.0737,3.5728Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Webhook.propTypes = iconPropTypes;
}
const Websheet = /*#__PURE__*/React.forwardRef(function Websheet({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "2"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,24,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,20Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Websheet.propTypes = iconPropTypes;
}
const Wheat = /*#__PURE__*/React.forwardRef(function Wheat({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M21,3V5.5857l-4,4V1H15V9.5857l-4-4V3H9V19a7.004,7.004,0,0,0,6,6.92V30h2V25.92A7.004,7.004,0,0,0,23,19V3ZM15,23.8987A5.008,5.008,0,0,1,11,19v-2.586l4,4Zm0-6.313-4-4V8.4138l4,4Zm2-5.1719,4-4v5.1719l-4,4Zm0,11.4849V20.4138l4-4V19A5.008,5.008,0,0,1,17,23.8987Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Wheat.propTypes = iconPropTypes;
}
const WhileLoop = /*#__PURE__*/React.forwardRef(function WhileLoop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M23,23h7v7h-2v-3.3518c-1.6447,2.0408-4.1525,3.3516-7.0002,3.3516l-9.9998.0002c-5,0-9-4-9-9v-8h2v8c0,3.8999,3.1,7,7,7h10c2.4032,0,4.4943-1.1841,5.7518-3h-3.7518v-2ZM9,7h-3.7518c1.2575-1.8159,3.3486-3,5.7518-3h10c3.9,0,7,3.1001,7,7v8h2v-8c0-5-4-9-9-9l-9.9998.0002c-2.8477,0-5.3555,1.3108-7.0002,3.3516V2h-2v7h7v-2ZM13.957,22l1.5303-6.3457.7739-3.1641h.0347l.7393,3.1641,1.5308,6.3457h2.562l2.8721-12.0029h-2.167l-1.2207,5.7607-.7568,3.6797h-.0518l-.8423-3.6797-1.376-5.7607h-2.5107l-1.3755,5.7607-.8599,3.6797h-.0518l-.7393-3.6797-1.1865-5.7607h-2.27l2.7856,12.0029h2.5796Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WhileLoop.propTypes = iconPropTypes;
}
const WhitePaper = /*#__PURE__*/React.forwardRef(function WhitePaper({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M22 27.1798L19.41 24.5899 18 26 22 30 30 22 28.5899 20.59 22 27.1798z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17H16V19H9z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12H21V14H9z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7H21V9H9z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "m16,30H6c-1.103,0-2-.8972-2-2V4c0-1.1028.897-2,2-2h18c1.103,0,2,.8972,2,2v15h-2V4H6v24h10v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WhitePaper.propTypes = iconPropTypes;
}
const Wifi = /*#__PURE__*/React.forwardRef(function Wifi({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "25",
    r: "2"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M10.47,19.2334l1.4136,1.4131a5.9688,5.9688,0,0,1,8.2229-.0093L21.52,19.2236a7.9629,7.9629,0,0,0-11.05.01Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M6.229,14.9927l1.4136,1.4135a11.955,11.955,0,0,1,16.7041-.01L25.76,14.9829a13.9514,13.9514,0,0,0-19.5313.01Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10.7412a19.94,19.94,0,0,0-28,0v.0225L3.4043,12.168a17.9336,17.9336,0,0,1,25.1811-.01L30,10.7432Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Wifi.propTypes = iconPropTypes;
}
const WifiController = /*#__PURE__*/React.forwardRef(function WifiController({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M6,30H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v6A2,2,0,0,0,6,30Zm0-8H26v6H6Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "25",
    r: "1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "14.5",
    r: "1.5"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7832,10.3325a7.0007,7.0007,0,0,1,10.4341,0l-1.49,1.334a5,5,0,0,0-7.4537,0Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1992,7.3994a11.0019,11.0019,0,0,1,17.6006,0L23.2,8.6a9.0009,9.0009,0,0,0-14.4014.0005Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WifiController.propTypes = iconPropTypes;
}
const WifiNotSecure = /*#__PURE__*/React.forwardRef(function WifiNotSecure({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20H14V17a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V22A2.0025,2.0025,0,0,0,20,20Zm0,8H12V22h8Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M16,8a8.9709,8.9709,0,0,0-6.3608,2.6392l1.4133,1.4135a6.9887,6.9887,0,0,1,9.895,0l1.4135-1.4135A8.9717,8.9717,0,0,0,16,8Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M6.105,7.105,7.5188,8.5186a11.9808,11.9808,0,0,1,16.9624,0L25.8949,7.105a13.9782,13.9782,0,0,0-19.79,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WifiNotSecure.propTypes = iconPropTypes;
}
const WifiOff = /*#__PURE__*/React.forwardRef(function WifiOff({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "25",
    r: "2"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4141,28.5859,2,2,28.5859,3.4141,30,14.0962,19.3179a5.9359,5.9359,0,0,1,6.01,1.3193L21.52,19.2236a7.9669,7.9669,0,0,0-5.125-2.2041l3.3875-3.3877a11.9908,11.9908,0,0,1,4.5647,2.7647L25.76,14.9829A13.975,13.975,0,0,0,21.334,12.08L24.3308,9.083a17.9364,17.9364,0,0,1,4.2546,3.0747L30,10.7432v-.002a20.02,20.02,0,0,0-4.1895-3.1377Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M14.68,13.0776l2.0415-2.0415C16.481,11.0234,16.2437,11,16,11a13.9447,13.9447,0,0,0-9.771,3.9927l1.4136,1.4136A11.97,11.97,0,0,1,14.68,13.0776Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7a17.87,17.87,0,0,1,4.2324.5254L21.875,5.8828A19.9537,19.9537,0,0,0,2,10.7412v.0225L3.4043,12.168A17.9193,17.9193,0,0,1,16,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WifiOff.propTypes = iconPropTypes;
}
const WifiSecure = /*#__PURE__*/React.forwardRef(function WifiSecure({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20V17a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V22A2.0025,2.0025,0,0,0,20,20Zm-6-3a2,2,0,0,1,4,0v3H14ZM12,28V22h8v6Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M6.105,7.105,7.5188,8.5186a11.9808,11.9808,0,0,1,16.9624,0L25.8949,7.105a13.9782,13.9782,0,0,0-19.79,0Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M16,8a8.9709,8.9709,0,0,0-6.3608,2.6392l1.4133,1.4135a6.9887,6.9887,0,0,1,9.895,0l1.4135-1.4135A8.9717,8.9717,0,0,0,16,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WifiSecure.propTypes = iconPropTypes;
}
const WifiBridge = /*#__PURE__*/React.forwardRef(function WifiBridge({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9492,20.95l-1.414-1.4141a5,5,0,0,0,0-7.0715L6.9492,11.05a7,7,0,0,1,0,9.9Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4854,24.4854,9.0713,23.0713a10.0011,10.0011,0,0,0,0-14.1426l1.4141-1.4141a12.0006,12.0006,0,0,1,0,16.9708Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0508,20.95a7,7,0,0,1,0-9.9l1.414,1.4146a5,5,0,0,0,0,7.0715Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5146,24.4854a12.0006,12.0006,0,0,1,0-16.9708l1.4141,1.4141a10.0011,10.0011,0,0,0,0,14.1426Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M3,15H2V4H0V28H2V17H3a1,1,0,0,0,0-2Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M30,4V15H29a1,1,0,0,0,0,2h1V28h2V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WifiBridge.propTypes = iconPropTypes;
}
const WifiBridgeAlt = /*#__PURE__*/React.forwardRef(function WifiBridgeAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M13,26H11a5.0057,5.0057,0,0,0-5-5V19A7.0078,7.0078,0,0,1,13,26Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M18,26H16A10.0113,10.0113,0,0,0,6,16V14A12.0137,12.0137,0,0,1,18,26Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M26,13a7.0078,7.0078,0,0,1-7-7h2a5.0057,5.0057,0,0,0,5,5Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A12.0137,12.0137,0,0,1,14,6h2A10.0113,10.0113,0,0,0,26,16Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M7.707,24.293a.9994.9994,0,0,0-1.414,0L2,28.5859,3.4143,30,7.707,25.707A.9994.9994,0,0,0,7.707,24.293Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5859,2,24.293,6.293a1,1,0,0,0,1.414,1.414L30,3.4141Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WifiBridgeAlt.propTypes = iconPropTypes;
}
const Wikis = /*#__PURE__*/React.forwardRef(function Wikis({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM28,15H22A24.26,24.26,0,0,0,19.21,4.45,12,12,0,0,1,28,15ZM16,28a5,5,0,0,1-.67,0A21.85,21.85,0,0,1,12,17H20a21.85,21.85,0,0,1-3.3,11A5,5,0,0,1,16,28ZM12,15a21.85,21.85,0,0,1,3.3-11,6,6,0,0,1,1.34,0A21.85,21.85,0,0,1,20,15Zm.76-10.55A24.26,24.26,0,0,0,10,15h-6A12,12,0,0,1,12.79,4.45ZM4.05,17h6a24.26,24.26,0,0,0,2.75,10.55A12,12,0,0,1,4.05,17ZM19.21,27.55A24.26,24.26,0,0,0,22,17h6A12,12,0,0,1,19.21,27.55Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Wikis.propTypes = iconPropTypes;
}
const WindGusts = /*#__PURE__*/React.forwardRef(function WindGusts({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3164,8.0513l-18-6A1,1,0,0,0,10.4,2.2L4,7V2H2V30H4V11l6.4,4.8a1,1,0,0,0,.9165.1489l18-6a1,1,0,0,0,0-1.8974ZM10,13,4.6665,9,10,5Zm4-.0542-2,.667V4.3872l2,.667Zm4-1.333-2,.6665V5.7207l2,.6665Zm2-.667V7.0542L25.8379,9Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M20,22a4,4,0,0,0-8,0h2a2,2,0,1,1,2,2H8v2h8A4.0045,4.0045,0,0,0,20,22Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a4.0045,4.0045,0,0,0-4,4h2a2,2,0,1,1,2,2H12v2H26a4,4,0,0,0,0-8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WindGusts.propTypes = iconPropTypes;
}
const WindPower = /*#__PURE__*/React.forwardRef(function WindPower({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M17,28V15.8159a3.0059,3.0059,0,0,0,1.47-1.1186L27.063,17l.5176-1.9321-8.6045-2.3052a2.985,2.985,0,0,0-2.63-2.7275L14.1938,2l-1.9316.5186,2.1318,7.956a2.9588,2.9588,0,0,0-1.093,3.8115L7,20.5859,8.415,22l6.3-6.3A2.8938,2.8938,0,0,0,15,15.8154V28H2v2H30V28Zm0-15a1,1,0,1,1-1-1A1.0008,1.0008,0,0,1,17,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WindPower.propTypes = iconPropTypes;
}
const WindStream = /*#__PURE__*/React.forwardRef(function WindStream({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2,23.5859,3.4141,26.1719,6h-5.09a16.93,16.93,0,0,0-6.3139,1.2158L10.4893,8.9272A14.93,14.93,0,0,1,4.9185,10H2v2H4.9185a16.93,16.93,0,0,0,6.3139-1.2158l4.2783-1.7114A14.93,14.93,0,0,1,21.0815,8h5.09l-2.586,2.5859L25,12l5-5Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M21,11l-1.4141,1.4141L22.1719,15H18.9014a16.9422,16.9422,0,0,0-5.9693,1.0825l-2.5664.9624A14.9456,14.9456,0,0,1,5.0986,18H2v2H5.0986a16.9422,16.9422,0,0,0,5.9693-1.0825l2.5664-.9624A14.9456,14.9456,0,0,1,18.9014,17h3.2705l-2.586,2.5859L21,21l5-5Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M17,20l-1.4141,1.4141L18.1719,24H16.5967a16.9879,16.9879,0,0,0-5.3765.8721l-1.0727.3584A14.9852,14.9852,0,0,1,5.4033,26H2v2H5.4033a16.9879,16.9879,0,0,0,5.3765-.8721l1.0727-.3584A14.9852,14.9852,0,0,1,16.5967,26h1.5752l-2.586,2.5859L17,30l5-5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WindStream.propTypes = iconPropTypes;
}
const WatsonHealthWindowAuto = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowAuto({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4H17V7H15z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15H28V17H25z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25H17V28H15z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15H7V17H4z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 7.04H9.55V10.04H7.55z",
    transform: "rotate(-45 8.55 8.548)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M21.96 7.55H24.96V9.55H21.96z",
    transform: "rotate(-45 23.454 8.555)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M22.45 21.95H24.45V24.95H22.45z",
    transform: "rotate(-45 23.452 23.446)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05 22.45H10.05V24.45H7.05z",
    transform: "rotate(-45 8.544 23.451)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M4 30H28V32H4z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M4 0H28V2H4z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Zm-4,6a4,4,0,0,1,4-4v8A4,4,0,0,1,12,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthWindowAuto.propTypes = iconPropTypes;
}
const WatsonHealthWindowBase = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowBase({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V5H15z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M25 13H28V15H25z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23H17V26H15z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13H7V15H4z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 5.03H9.55V8.030000000000001H7.55z",
    transform: "rotate(-45 8.56 6.544)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M21.96 5.54H24.96V7.54H21.96z",
    transform: "rotate(-45 23.469 6.539)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M22.46 19.94H24.46V22.94H22.46z",
    transform: "rotate(-45 23.462 21.442)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04 20.45H10.04V22.45H7.04z",
    transform: "rotate(-45 8.554 21.447)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28H28V30H4z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a6,6,0,1,0-6-6A6,6,0,0,0,16,20Zm0-10v8a4,4,0,0,1,0-8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthWindowBase.propTypes = iconPropTypes;
}
const WatsonHealthWindowBlackSaturation = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowBlackSaturation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V5H15z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15H30V17H27z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27H17V30H15z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15H5V17H2z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M6.225 5.729H8.228V8.732H6.225z",
    transform: "rotate(-45 7.227 7.23)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M23.267 6.227H26.267V8.227H23.267z",
    transform: "rotate(-45 24.767 7.227)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M23.769 23.269H25.770999999999997V26.270999999999997H23.769z",
    transform: "rotate(-44.999 24.77 24.77)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47 25.126L7.591 23 9 24.419 6.884 26.54 5.47 25.126z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13H17V15H15z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13H21V15H19z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11H19V13H17z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15H19V17H17z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19H19V21H17z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17H17V19H15z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H21V19H19z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7a9,9,0,1,0,9,9A9.01,9.01,0,0,0,16,7ZM9,16a7.004,7.004,0,0,1,6-6.92V11h2V9.08a6.9231,6.9231,0,0,1,2,.605V11h1.89c.0374.0366.074.0732.11.11V13h1.3149a6.931,6.931,0,0,1,.6053,2H21v2h1.92a6.931,6.931,0,0,1-.6053,2H21v1.89c-.0364.0372-.073.0738-.11.11H19v1.3149a6.9231,6.9231,0,0,1-2,.605V21H15v1.92A7.004,7.004,0,0,1,9,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthWindowBlackSaturation.propTypes = iconPropTypes;
}
const WatsonHealthWindowOverlay = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowOverlay({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H17V9H15z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M25 17H28V19H25z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27H17V30H15z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17H7V19H4z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 9.03H9.55V12.03H7.55z",
    transform: "rotate(-45 8.558 10.545)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M21.96 9.54H24.96V11.54H21.96z",
    transform: "rotate(-45 23.466 10.54)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M22.46 23.94H24.46V26.94H22.46z",
    transform: "rotate(-45 23.459 25.443)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04 24.45H10.04V26.45H7.04z",
    transform: "rotate(-45 8.55 25.448)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H28V4H4z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a6,6,0,1,0-6-6A6,6,0,0,0,16,24Zm0-10v8a4,4,0,0,1,0-8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthWindowOverlay.propTypes = iconPropTypes;
}
const WatsonHealthWindowPreset = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowPreset({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H17V8H15z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15H26V17H24z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24H17V26H15z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15H8V17H6z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M8.586 8.586H10.586V10.586H8.586z",
    transform: "rotate(-45 9.586 9.586)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M21.414 8.586H23.414V10.586H21.414z",
    transform: "rotate(-45 22.414 9.586)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M21.414 21.414H23.414V23.414H21.414z",
    transform: "rotate(-45 22.414 22.414)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M8.586 21.414H10.586V23.414H8.586z",
    transform: "rotate(-45 9.586 22.414)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,0-6-6A6,6,0,0,0,16,22Zm0-10v8a4,4,0,0,1,0-8Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthWindowPreset.propTypes = iconPropTypes;
}
const Windy = /*#__PURE__*/React.forwardRef(function Windy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M21,15H8V13H21a3,3,0,1,0-3-3H16a5,5,0,1,1,5,5Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M23,28a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H4V18H23a5,5,0,0,1,0,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Windy.propTypes = iconPropTypes;
}
const WindyDust = /*#__PURE__*/React.forwardRef(function WindyDust({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M23,28a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H22V18h1a5,5,0,0,1,0,10Z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18H20V20H16z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H14V20H10z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18H8V20H4z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M21,15H20V13h1a3,3,0,1,0-3-3H16a5,5,0,1,1,5,5Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13H18V15H14z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13H12V15H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WindyDust.propTypes = iconPropTypes;
}
const WindySnow = /*#__PURE__*/React.forwardRef(function WindySnow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M25,28a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H6V18H25a5,5,0,0,1,0,10Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M23,15H10V13H23a3,3,0,1,0-3-3H18a5,5,0,1,1,5,5Z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M11 23H13V25H11z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25H15V27H13z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27H17V29H15z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23H17V25H15z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M11 27H13V29H11z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4H8V6H6z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H10V8H8z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8H12V10H10z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4H12V6H10z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8H8V10H6z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H4V28H2z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28H6V30H4z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M6 30H8V32H6z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M6 26H8V28H6z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M2 30H4V32H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WindySnow.propTypes = iconPropTypes;
}
const WindyStrong = /*#__PURE__*/React.forwardRef(function WindyStrong({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M13,30a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H4V20h9a5,5,0,0,1,0,10Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M25,25a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H2V15H25a5,5,0,0,1,0,10Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M21,12H6V10H21a3,3,0,1,0-3-3H16a5,5,0,1,1,5,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WindyStrong.propTypes = iconPropTypes;
}
const WinterWarning = /*#__PURE__*/React.forwardRef(function WinterWarning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M21.684 19.051L19.167 19.891 13 15.486 13 7.369 15.555 5.665 14.445 4.001 12 5.631 9.555 4.001 8.445 5.665 11 7.369 11 14.057 6 10.486 6 8 4 8 4 10.279 1.684 11.051 2.316 12.949 4.833 12.11 10.28 16.001 4.833 19.891 2.316 19.051 1.684 20.949 4 21.721 4 24 6 24 6 21.515 11 17.944 11 24.631 8.445 26.335 9.555 27.999 12 26.368 14.445 27.999 15.555 26.335 13 24.631 13 17.943 18 21.515 18 24 20 24 20 21.721 22.316 20.949 21.684 19.051z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WinterWarning.propTypes = iconPropTypes;
}
const WintryMix = /*#__PURE__*/React.forwardRef(function WintryMix({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26H17V28H15z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M17 28H19V30H17z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M19 30H21V32H19z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26H21V28H19z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M15 30H17V32H15z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16H15V18H13z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H17V20H15z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20H19V22H17z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16H19V18H17z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20H15V22H13z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M10,30a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7888.8947l-2,4A.9981.9981,0,0,1,10,30Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.5321,6.5321,0,0,0,2,15.5V22l1,2,1-2V20.18a6.4891,6.4891,0,0,0,3.4294,1.7246L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418.977.977,0,0,0-.489-.0894V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20h-.542v.0083A.9955.9955,0,0,0,22,21v3l1,2,1-2V21.9746a6.4473,6.4473,0,0,0,2-.4761V26l1,2,1-2V20.18A6.4876,6.4876,0,0,0,24.8008,9.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WintryMix.propTypes = iconPropTypes;
}
const WirelessCheckout = /*#__PURE__*/React.forwardRef(function WirelessCheckout({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28V26A10,10,0,0,0,28,16h2A12,12,0,0,1,18,28Z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23V21a5,5,0,0,0,5-5h2A7,7,0,0,1,18,23Z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11H21V7a3,3,0,0,0-3-3H12A3,3,0,0,0,9,7v4H3a1,1,0,0,0-1,1.15L3.88,24.3a2,2,0,0,0,2,1.7H15V24H5.86L4.17,13H27ZM11,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WirelessCheckout.propTypes = iconPropTypes;
}
const Wmv = /*#__PURE__*/React.forwardRef(function Wmv({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M29 9L27 22 25 9 23 9 25.52 23 28.48 23 31 9 29 9z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9L17.48 14 17 15.98 16.54 14 15 9 13 9 13 23 15 23 15 15 14.84 13 15.42 15 17 19.63 18.58 15 19.16 13 19 15 19 23 21 23 21 9 19 9z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 9L8.86 17 8.6 21.54 8.19 18 7.51 12.54 5.49 12.54 4.81 18 4.4 21.54 4.14 17 3.8 9 2 9 3 23 5.27 23 6.03 18.07 6.49 14 6.5 13.97 6.51 14 6.97 18.07 7.73 23 10 23 11 9 9.2 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Wmv.propTypes = iconPropTypes;
}
const WordCloud = /*#__PURE__*/React.forwardRef(function WordCloud({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16H22V18H10z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20H18V22H10z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7h0a8.0233,8.0233,0,0,1,7.8649,6.4935l.2591,1.346,1.3488.244A5.5019,5.5019,0,0,1,24.5076,26H7.4954a5.5019,5.5019,0,0,1-.9695-10.9165l1.3488-.244.2591-1.346A8.0256,8.0256,0,0,1,16,7m0-2a10.0244,10.0244,0,0,0-9.83,8.1155A7.5019,7.5019,0,0,0,7.4911,28H24.5076a7.5019,7.5019,0,0,0,1.3213-14.8845A10.0229,10.0229,0,0,0,15.9883,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WordCloud.propTypes = iconPropTypes;
}
const WorkflowAutomation = /*#__PURE__*/React.forwardRef(function WorkflowAutomation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,27c-3.6,0-7.1-1.8-9.2-5H12v-2H4v8h2v-3.7c2.5,3,6.1,4.7,10,4.7V27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,23v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V15h-2v2.1 c-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H17v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5 l1.4,1.4l1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V29h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8 H31z M24,25c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S25.7,25,24,25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,10h5.2C21.9,4.9,15.1,3.5,10,6.8c-3.1,2-5,5.5-5,9.2H3C3,8.8,8.8,3,16,3c3.9,0,7.5,1.7,10,4.7V4h2v8h-8V10z"
  })))), children);
});
if (process.env.NODE_ENV !== "production") {
  WorkflowAutomation.propTypes = iconPropTypes;
}
const Workspace = /*#__PURE__*/React.forwardRef(function Workspace({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M16,17v8H6V17H16m0-2H6a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V17a2,2,0,0,0-2-2Z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M27,6v5H17V6H27m0-2H17a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M27,17v5H22V17h5m0-2H22a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2h5a2,2,0,0,0,2-2V17a2,2,0,0,0-2-2Z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M11,6v5H6V6h5m0-2H6A2,2,0,0,0,4,6v5a2,2,0,0,0,2,2h5a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Workspace.propTypes = iconPropTypes;
}
const WorkspaceImport = /*#__PURE__*/React.forwardRef(function WorkspaceImport({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M27,6v5H17V6H27m0-2H17a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M12,25H6V17h6V15H6a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h6Z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M30 20L16.828 20 19.414 17.414 18 16 13 21 18 26 19.414 24.586 16.828 22 30 22 30 20z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M11,6v5H6V6h5m0-2H6A2,2,0,0,0,4,6v5a2,2,0,0,0,2,2h5a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WorkspaceImport.propTypes = iconPropTypes;
}
const Worship = /*#__PURE__*/React.forwardRef(function Worship({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5859,17,22,21.5859v0h0l-5-5a2.002,2.002,0,0,0-2.8286,0L9.585,21.1709A2.0031,2.0031,0,0,0,9.585,24l4.0009,4H6v2H16a1,1,0,0,0,.707-1.707L11,22.585,15.5852,18l5.7078,5.707a.9995.9995,0,0,0,1.414,0L28,18.4141Z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5,17A3.5,3.5,0,1,1,25,13.5,3.5042,3.5042,0,0,1,21.5,17Zm0-5A1.5,1.5,0,1,0,23,13.5,1.5017,1.5017,0,0,0,21.5,12Z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M4,10.5977l12-6.462,12.5264,6.7452.9472-1.7618-13-7a1.0045,1.0045,0,0,0-.9472,0l-13,7A1,1,0,0,0,2,10V30H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Worship.propTypes = iconPropTypes;
}
const WorshipChristian = /*#__PURE__*/React.forwardRef(function WorshipChristian({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M17,30H15a2.0021,2.0021,0,0,1-2-2V14H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8h5V4a2.0021,2.0021,0,0,1,2-2h2a2.0021,2.0021,0,0,1,2,2V8h5a2.0021,2.0021,0,0,1,2,2v2a2.0021,2.0021,0,0,1-2,2H19V28A2.0021,2.0021,0,0,1,17,30ZM8,10v2h7V28h2V12h7V10H17V4H15v6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WorshipChristian.propTypes = iconPropTypes;
}
const WorshipJewish = /*#__PURE__*/React.forwardRef(function WorshipJewish({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M24.291,16l3.585-6.5181A1,1,0,0,0,27,8H19.8911L16.876,2.5181a1,1,0,0,0-1.752,0L12.1089,8H5a1,1,0,0,0-.876,1.4819L7.709,16,4.124,22.5181A1,1,0,0,0,5,24h7.1089l3.0151,5.4819a1,1,0,0,0,1.752,0L19.8911,24H27a1,1,0,0,0,.876-1.4819Zm-5.5823,6L16,26.9248,13.2913,22h-6.6l3.3-6-3.3-6h6.6L16,5.0752,18.7087,10h6.6l-3.3,6,3.3,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WorshipJewish.propTypes = iconPropTypes;
}
const WorshipMuslim = /*#__PURE__*/React.forwardRef(function WorshipMuslim({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M27,18a.9986.9986,0,0,1-.5415-.1594L22,14.9688l-4.4585,2.8718a1,1,0,0,1-1.5088-1.095l1.35-5.1318L14.3105,8.69a1,1,0,0,1,.5508-1.7146l4.3745-.6128,1.8663-3.8032A1.0008,1.0008,0,0,1,21.9878,2a1.0171,1.0171,0,0,1,.8989.5378L24.88,6.3625l4.2622.6133A1,1,0,0,1,29.69,8.69l-3.0723,2.9239,1.35,5.1318A1,1,0,0,1,27,18Zm-5-5.2207a.999.999,0,0,1,.5415.1594l2.8369,1.8272-.8457-3.2149a1.0006,1.0006,0,0,1,.2778-.9787l2.0074-1.91-2.73-.3929a.9994.9994,0,0,1-.7441-.5275L22.0269,5.2151,20.7979,7.72a1.0008,1.0008,0,0,1-.7593.55L17.19,8.6687l2,1.9036a1.0006,1.0006,0,0,1,.2778.9787l-.8457,3.2149,2.8369-1.8272A.999.999,0,0,1,22,12.7793Z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8169,30A13.8137,13.8137,0,0,1,9.0752,4.1277a1,1,0,0,1,1.3613,1.3611A11.8091,11.8091,0,0,0,26.5107,21.5635a1,1,0,0,1,1.3619,1.3611A13.8411,13.8411,0,0,1,15.8169,30ZM7.3271,7.9727a11.81,11.81,0,0,0,16.7,16.7,13.8086,13.8086,0,0,1-16.7-16.7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WorshipMuslim.propTypes = iconPropTypes;
}
const QX = /*#__PURE__*/React.forwardRef(function QX({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9L18 9 16 15 14 9 12 9 14.75 16 12 23 14 23 16 17 18 23 20 23 17.25 16 20 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QX.propTypes = iconPropTypes;
}
const XAxis = /*#__PURE__*/React.forwardRef(function XAxis({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M23,20l-1.4141,1.4141L24.1719,24H6V4H4V24a2.0023,2.0023,0,0,0,2,2H24.1719l-2.586,2.5859L23,30l5-5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  XAxis.propTypes = iconPropTypes;
}
const Xls = /*#__PURE__*/React.forwardRef(function Xls({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M28,23H22V21h6V17H24a2.002,2.002,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h6v2H24v4h4a2.002,2.002,0,0,1,2,2v4A2.0023,2.0023,0,0,1,28,23Z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21L14 9 12 9 12 23 20 23 20 21 14 21z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9L8 9 6 15 4 9 2 9 4.752 16 2 23 4 23 6 17 8 23 10 23 7.245 16 10 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Xls.propTypes = iconPropTypes;
}
const Xml = /*#__PURE__*/React.forwardRef(function Xml({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21L24 9 22 9 22 23 30 23 30 21 24 21z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L16.48 14 16 15.98 15.54 14 14 9 12 9 12 23 14 23 14 15 13.84 13 14.42 15 16 19.63 17.58 15 18.16 13 18 15 18 23 20 23 20 9 18 9z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9L8 9 6 15 4 9 2 9 4.75 16 2 23 4 23 6 17 8 23 10 23 7.25 16 10 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Xml.propTypes = iconPropTypes;
}
const QY = /*#__PURE__*/React.forwardRef(function QY({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9L18 9 16 16 14 9 12 9 15 18 15 23 17 23 17 18 20 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QY.propTypes = iconPropTypes;
}
const YAxis = /*#__PURE__*/React.forwardRef(function YAxis({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M8,26V7.8281l2.5859,2.586L12,9,7,4,2,9l1.4141,1.4141L6,7.8281V26a2.0023,2.0023,0,0,0,2,2H28V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  YAxis.propTypes = iconPropTypes;
}
const QZ = /*#__PURE__*/React.forwardRef(function QZ({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9L12 9 12 11 18 11 12 21 12 23 20 23 20 21 14 21 20 11 20 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QZ.propTypes = iconPropTypes;
}
const ZLpar = /*#__PURE__*/React.forwardRef(function ZLpar({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10h4c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3c-1.1046,0-2,.8954-2,2V15h-3V5c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2V27c0,1.1046,.8954,2,2,2H12c1.1046,0,2-.8954,2-2v-10h3v8c0,1.1046,.8954,2,2,2h3v1c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3v-8h3v1c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3V7h3v1c0,1.1046,.8954,2,2,2Zm0-6h4v4s-4,0-4,0V4ZM11.3992,12l-7.3992,5.9194V6.0806l7.3992,5.9194Zm.6013,2.0801l.0007,11.8403-7.4004-5.9204,7.3997-5.9199Zm-.0002-4.1606L5.8508,5h6.1492l.0002,4.9194ZM4,22.0806l6.1492,4.9194H4v-4.9194Zm20,1.9194h4v4h-4v-4Zm0-10h4v4h-4v-4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZLpar.propTypes = iconPropTypes;
}
const ZSystems = /*#__PURE__*/React.forwardRef(function ZSystems({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3h-8c-1.1028,0-2,.8975-2,2V27c0,1.1025,.8972,2,2,2h8c1.1028,0,2-.8975,2-2V5c0-1.1025-.8972-2-2-2Zm.0002,6.9194l-6.1494-4.9194h6.1492l.0002,4.9194Zm-.6011,2.0806l-7.3992,5.9194V6.0806l7.3992,5.9194Zm.6013,2.0801l.0007,11.8403-7.4004-5.9204,7.3997-5.9199Zm-8.0005,8.0005l6.1492,4.9194h-6.1492v-4.9194Z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M13,3H5c-1.1028,0-2,.8975-2,2V27c0,1.1025,.8972,2,2,2H13c1.1028,0,2-.8975,2-2V5c0-1.1025-.8972-2-2-2Zm.0002,6.9194L6.8508,5h6.1492l.0002,4.9194Zm-.6011,2.0806l-7.3992,5.9194V6.0806l7.3992,5.9194Zm.6013,2.0801l.0007,11.8403-7.4004-5.9204,7.3997-5.9199ZM5,22.0806l6.1492,4.9194H5v-4.9194Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZSystems.propTypes = iconPropTypes;
}
const ZAxis = /*#__PURE__*/React.forwardRef(function ZAxis({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M26 22L26 25.586 17 16.586 17 10 17 6 17 5.828 19.586 8.414 21 7 16 2 11 7 12.414 8.414 15 5.828 15 6 15 10 15 16.586 6 25.586 6 22 4 22 4 29 11 29 11 27 7.414 27 16 18.414 24.586 27 21 27 21 29 28 29 28 22 26 22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZAxis.propTypes = iconPropTypes;
}
const Zip = /*#__PURE__*/React.forwardRef(function Zip({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M28,9H22V23h2V18h4a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9Zm0,7H24V11h4Z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9L12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9L2 9 2 11 8 11 2 21 2 23 10 23 10 21 4 21 10 11 10 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Zip.propTypes = iconPropTypes;
}
const ZipReference = /*#__PURE__*/React.forwardRef(function ZipReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H22V16h2V11h4a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2Zm0,7H24V4h4Z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4L15 4 15 14 12 14 12 16 20 16 20 14 17 14 17 4 20 4 20 2 12 2 12 4z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4L8 4 2 14 2 16 10 16 10 14 4 14 10 4 10 2 2 2 2 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZipReference.propTypes = iconPropTypes;
}
const ZoomArea = /*#__PURE__*/React.forwardRef(function ZoomArea({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M31,29.5859l-4.6885-4.6884a8.028,8.028,0,1,0-1.414,1.414L29.5859,31ZM20,26a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,20,26Z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M8,26H4a2.0021,2.0021,0,0,1-2-2V20H4v4H8Z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H4V16H2z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M26,8H24V4H20V2h4a2.0021,2.0021,0,0,1,2,2Z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2H16V4H12z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M4,8H2V4A2.0021,2.0021,0,0,1,4,2H8V4H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZoomArea.propTypes = iconPropTypes;
}
const ZoomFit = /*#__PURE__*/React.forwardRef(function ZoomFit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M10,12H8V10a2.0023,2.0023,0,0,1,2-2h2v2H10Z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M18,12H16V10H14V8h2a2.0023,2.0023,0,0,1,2,2Z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M12,18H10a2.0023,2.0023,0,0,1-2-2V14h2v2h2Z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18H14V16h2V14h2v2A2.0023,2.0023,0,0,1,16,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZoomFit.propTypes = iconPropTypes;
}
const ZoomIn = /*#__PURE__*/React.forwardRef(function ZoomIn({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
      d: "M9 6L7 6 7 4 6 4 6 6 4 6 4 7 6 7 6 9 7 9 7 7 9 7z"
    })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
      d: "M10.7,10C11.5,9,12,7.8,12,6.5C12,3.5,9.5,1,6.5,1S1,3.5,1,6.5S3.5,12,6.5,12c1.3,0,2.5-0.5,3.5-1.3l3.8,3.8l0.7-0.7 L10.7,10z M6.5,11C4,11,2,9,2,6.5S4,2,6.5,2S11,4,11,6.5S9,11,6.5,11L6.5,11z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12L14 12 14 8 12 8 12 12 8 12 8 14 12 14 12 18 14 18 14 14 18 14 18 12z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZoomIn.propTypes = iconPropTypes;
}
const ZoomInArea = /*#__PURE__*/React.forwardRef(function ZoomInArea({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M24 19L21 19 21 16 19 16 19 19 16 19 16 21 19 21 19 24 21 24 21 21 24 21 24 19z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M31,29.5859l-4.6885-4.6884a8.028,8.028,0,1,0-1.414,1.414L29.5859,31ZM20,26a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,20,26Z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M4,8H2V4A2.0021,2.0021,0,0,1,4,2H8V4H4Z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M26,8H24V4H20V2h4a2.0021,2.0021,0,0,1,2,2Z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2H16V4H12z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M8,26H4a2.0021,2.0021,0,0,1-2-2V20H4v4H8Z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H4V16H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZoomInArea.propTypes = iconPropTypes;
}
const ZoomOut = /*#__PURE__*/React.forwardRef(function ZoomOut({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
      d: "M4 6H9V7H4z"
    })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
      d: "M10.7,10C11.5,9,12,7.8,12,6.5C12,3.5,9.5,1,6.5,1S1,3.5,1,6.5S3.5,12,6.5,12c1.3,0,2.5-0.5,3.5-1.3l3.8,3.8l0.7-0.7 L10.7,10z M6.5,11C4,11,2,9,2,6.5S4,2,6.5,2S11,4,11,6.5S9,11,6.5,11L6.5,11z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H18V14H8z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZoomOut.propTypes = iconPropTypes;
}
const ZoomOutArea = /*#__PURE__*/React.forwardRef(function ZoomOutArea({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19H24V21H16z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M31,29.5859l-4.6885-4.6884a8.028,8.028,0,1,0-1.414,1.414L29.5859,31ZM20,26a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,20,26Z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M4,8H2V4A2.0021,2.0021,0,0,1,4,2H8V4H4Z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M26,8H24V4H20V2h4a2.0021,2.0021,0,0,1,2,2Z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2H16V4H12z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M8,26H4a2.0021,2.0021,0,0,1-2-2V20H4v4H8Z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H4V16H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZoomOutArea.propTypes = iconPropTypes;
}
const ZoomReset = /*#__PURE__*/React.forwardRef(function ZoomReset({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4478,21A10.855,10.855,0,0,0,25,14,10.99,10.99,0,0,0,6,6.4658V2H4v8h8V8H7.332a8.9768,8.9768,0,1,1-2.1,8H3.1912A11.0118,11.0118,0,0,0,14,25a10.855,10.855,0,0,0,7-2.5522L28.5859,30,30,28.5859Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZoomReset.propTypes = iconPropTypes;
}
const WatsonHealthZoomPan = /*#__PURE__*/React.forwardRef(function WatsonHealthZoomPan({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M27.01 12L25.6 13.41 28.18 16 25.59 18.59 27.01 20 31.01 16 27.01 12z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41 13.42L5 12 1 16 5 20 6.42 18.59 3.83 16 6.41 13.42z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28.17L13.41 25.58 12 27 16 31 20 27 18.59 25.59 16 28.17z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.83L18.58 6.41 20 5 16 1 12 5 13.41 6.42 16 3.83z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M22,16a6,6,0,1,0-2.53,4.89l3.82,3.82,1.42-1.42-3.82-3.82A6,6,0,0,0,22,16Zm-6,4a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthZoomPan.propTypes = iconPropTypes;
}
const Zos = /*#__PURE__*/React.forwardRef(function Zos({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M30,22h-5v-2h5v-3h-3c-1.1028,0-2-.8972-2-2v-3c0-1.1028,.8972-2,2-2h5v2h-5v3h3c1.1028,0,2,.8972,2,2v3c0,1.1028-.8972,2-2,2Z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M21,22h-3c-1.1028,0-2-.8972-2-2V12c0-1.1028,.8972-2,2-2h3c1.1028,0,2,.8972,2,2v8c0,1.1028-.8972,2-2,2Zm-3-10v8h3V12h-3Z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9458 10L7.9458 22 10.0542 22 14.0542 10 11.9458 10z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22L0 22 0 19.6973 3.7981 14 0 14 0 12 6 12 6 14.3027 2.2019 20 6 20 6 22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Zos.propTypes = iconPropTypes;
}
const ZosSysplex = /*#__PURE__*/React.forwardRef(function ZosSysplex({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M20,14h8c1.1028,0,2-.8975,2-2V4c0-1.1025-.8972-2-2-2h-8c-1.1028,0-2,.8975-2,2v1H9c-1.1028,0-2,.8975-2,2v3H4c-1.1028,0-2,.8975-2,2v8c0,1.1025,.8972,2,2,2h3v3c0,1.1025,.8972,2,2,2h9v1c0,1.1025,.8972,2,2,2h8c1.1028,0,2-.8975,2-2v-8c0-1.1025-.8972-2-2-2h-8c-1.1028,0-2,.8975-2,2v5H9v-3h3c1.1028,0,2-.8975,2-2V12c0-1.1025-.8972-2-2-2h-3v-3h9v5c0,1.1025,.8972,2,2,2Zm1.4141,14l6.5862-6.5859-.0002,6.5859h-6.5859Zm5.1719-8l-6.5859,6.5859v-6.5859h6.5859ZM10.5522,12l-6.5522,6.5522v-6.5522h6.5522Zm-5.1719,8l6.6199-6.6196,.001,6.6196H5.3804ZM21.4141,12l6.5862-6.5859-.0002,6.5859h-6.5859Zm5.1719-8l-6.5859,6.5859V4h6.5859Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZosSysplex.propTypes = iconPropTypes;
}

export { QX, QY, QZ, VolumeDownFilled, VolumeDownFilledAlt, VolumeFileStorage, VolumeMute, VolumeMuteFilled, VolumeObjectStorage, VolumeUp, VolumeUpAlt, VolumeUpFilled, VolumeUpFilledAlt, Vpn, VpnConnection, VpnPolicy, Wallet, Warning, WarningAlt, WarningAltFilled, WarningAltInverted, WarningAltInvertedFilled, WarningDiamond, WarningFilled, WarningHex, WarningHexFilled, WarningMultiple, WarningOther, WarningSquare, WarningSquareFilled, Watch, Watson, WatsonHealthWindowAuto, WatsonHealthWindowBase, WatsonHealthWindowBlackSaturation, WatsonHealthWindowOverlay, WatsonHealthWindowPreset, WatsonHealthZoomPan, WatsonMachineLearning, Watsonx, WatsonxAi, WatsonxData, WatsonxGovernance, WaveDirection, WaveHeight, WavePeriod, WeatherFrontCold, WeatherFrontStationary, WeatherFrontWarm, WeatherStation, WebServicesCluster, WebServicesContainer, WebServicesDefinition, WebServicesService, WebServicesTask, WebServicesTaskDefinitionVersion, Webhook, Websheet, Wheat, WhileLoop, WhitePaper, Wifi, WifiBridge, WifiBridgeAlt, WifiController, WifiNotSecure, WifiOff, WifiSecure, Wikis, WindGusts, WindPower, WindStream, Windy, WindyDust, WindySnow, WindyStrong, WinterWarning, WintryMix, WirelessCheckout, Wmv, WordCloud, WorkflowAutomation, Workspace, WorkspaceImport, Worship, WorshipChristian, WorshipJewish, WorshipMuslim, XAxis, Xls, Xml, YAxis, ZAxis, ZLpar, ZSystems, Zip, ZipReference, ZoomArea, ZoomFit, ZoomIn, ZoomInArea, ZoomOut, ZoomOutArea, ZoomReset, Zos, ZosSysplex };
